import { useSelector } from "react-redux";
import { AppState } from "store";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import useReceiptPermissions from "./usePermissions";

function useReceiptTodoHelpers() {
  const loggedInUserId = useSelector((state: AppState) => state.auth.loggedInUser.personId);

  const { getReceiptAdminPermissions } = useReceiptPermissions();

  const updateReceiptTodo = (
    receipt: WintSuperkollAPIModel.Receipt,
    updateTodo: (receipt: WintSuperkollAPIModel.Receipt) => void,
    markAsDone: () => void,
    forceMarkAsDone?: boolean
  ) => {
    if (forceMarkAsDone) {
      return markAsDone();
    }

    const isReceiptAdmin = getReceiptAdminPermissions();
    if (
      (receipt.state === WintSuperkollAPIModel.ReceiptStateApiModel.WaitingAcceptance && isReceiptAdmin) ||
      ((receipt.state === WintSuperkollAPIModel.ReceiptStateApiModel.Draft ||
        receipt.state === WintSuperkollAPIModel.ReceiptStateApiModel.SentBackToCustomer ||
        receipt.state === WintSuperkollAPIModel.ReceiptStateApiModel.SentBackFromReceiptAdmin) &&
        receipt.createdByPersonId === loggedInUserId)
    ) {
      updateTodo(receipt);
    } else {
      markAsDone();
    }
  };

  return { updateReceiptTodo };
}

export default useReceiptTodoHelpers;
